module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "box-text margin-top-60"
  }, [_c('h1', {
    staticClass: "lato size-34 margin-bottom-40 txt-black"
  }, [_vm._v("Preguntas frecuentes")])]), _vm._v(" "), _c('div', {
    staticClass: "clear-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-group smart-accordion-default",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#panel1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tHow do I change or cancel my order?\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "panel1"
    }
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_vm._v("You may change or cancel an order on your orders page on our website. Click on the order you’d like to change. You can adjust the quantity of items or add items to your order by placing an additional order during the same delivery window. If you are unable to change your order, please contact our Customer Care Team and we’ll do our best to assist you.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#panel2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tHow much do meals cost?\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "panel2"
    }
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_vm._v("Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#panel3"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tWhere and when do you deliver?\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "panel3"
    }
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_vm._v("Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#panel4"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tHas my order been submitted successfully?\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "panel4"
    }
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_vm._v("Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#panel5"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tHas my order been Do I have to be home for delivery?\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "panel5"
    }
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_vm._v("Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#panel6"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tWhat is Andalepide Membership?\n\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "panel6"
    }
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_vm._v("Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-571bbd4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/static/Faq.vue
// module id = 1129
// module chunks = 5